import * as ambassadorWixSocialGroupsV2JoinGroupRequest from './social-groups-v2-join-group-request-join-group-requests.http.js';
import * as ambassadorWixSocialGroupsV2JoinGroupRequestTypes from './social-groups-v2-join-group-request-join-group-requests.types.js';
import * as ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes from './social-groups-v2-join-group-request-join-group-requests.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function approveJoinGroupRequests(): __PublicMethodMetaInfo<
  'POST',
  { groupId: string },
  ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes.ApproveJoinGroupRequestsRequest,
  ambassadorWixSocialGroupsV2JoinGroupRequestTypes.ApproveJoinGroupRequestsRequest,
  ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes.ApproveJoinGroupRequestsResponse,
  ambassadorWixSocialGroupsV2JoinGroupRequestTypes.ApproveJoinGroupRequestsResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2JoinGroupRequest.approveJoinGroupRequests(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups/{groupId}/join-requests/approve',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function rejectJoinGroupRequests(): __PublicMethodMetaInfo<
  'POST',
  { groupId: string },
  ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes.RejectJoinGroupRequestsRequest,
  ambassadorWixSocialGroupsV2JoinGroupRequestTypes.RejectJoinGroupRequestsRequest,
  ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes.RejectJoinGroupRequestsResponse,
  ambassadorWixSocialGroupsV2JoinGroupRequestTypes.RejectJoinGroupRequestsResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2JoinGroupRequest.rejectJoinGroupRequests(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups/{groupId}/join-requests/reject',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listJoinGroupRequests(): __PublicMethodMetaInfo<
  'GET',
  { groupId: string },
  ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes.ListJoinGroupRequestsRequest,
  ambassadorWixSocialGroupsV2JoinGroupRequestTypes.ListJoinGroupRequestsRequest,
  ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes.ListJoinGroupRequestsResponse,
  ambassadorWixSocialGroupsV2JoinGroupRequestTypes.ListJoinGroupRequestsResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2JoinGroupRequest.listJoinGroupRequests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/groups/{groupId}/join-requests',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryJoinGroupRequests(): __PublicMethodMetaInfo<
  'POST',
  { groupId: string },
  ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes.QueryJoinGroupRequestsRequest,
  ambassadorWixSocialGroupsV2JoinGroupRequestTypes.QueryJoinGroupRequestsRequest,
  ambassadorWixSocialGroupsV2JoinGroupRequestUniversalTypes.QueryJoinGroupRequestsResponse,
  ambassadorWixSocialGroupsV2JoinGroupRequestTypes.QueryJoinGroupRequestsResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2JoinGroupRequest.queryJoinGroupRequests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups/{groupId}/join-requests/query',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  JoinGroupRequest as JoinGroupRequestOriginal,
  RequestStatus as RequestStatusOriginal,
  RequestStatusWithLiterals as RequestStatusWithLiteralsOriginal,
  RequestDetails as RequestDetailsOriginal,
  SocialGroupsEvent as SocialGroupsEventOriginal,
  SocialGroupsEventPayloadOneOf as SocialGroupsEventPayloadOneOfOriginal,
  MemberJoinedGroup as MemberJoinedGroupOriginal,
  MembersAddedToGroup as MembersAddedToGroupOriginal,
  JoinRequestsApproved as JoinRequestsApprovedOriginal,
  MembersInvitedToGroup as MembersInvitedToGroupOriginal,
  GetJoinRequirementsRequest as GetJoinRequirementsRequestOriginal,
  MembershipQuestionAnswer as MembershipQuestionAnswerOriginal,
  GetJoinRequirementsResponse as GetJoinRequirementsResponseOriginal,
  PaidPlan as PaidPlanOriginal,
  ViolationType as ViolationTypeOriginal,
  ViolationTypeWithLiterals as ViolationTypeWithLiteralsOriginal,
  EventsViolationOptions as EventsViolationOptionsOriginal,
  PricingPlanViolationOptions as PricingPlanViolationOptionsOriginal,
  MembershipQuestionViolationOptions as MembershipQuestionViolationOptionsOriginal,
  Violation as ViolationOriginal,
  ViolationViolationOptionsOneOf as ViolationViolationOptionsOneOfOriginal,
  SubmitJoinGroupRequestRequest as SubmitJoinGroupRequestRequestOriginal,
  SubmitJoinGroupRequestResponse as SubmitJoinGroupRequestResponseOriginal,
  CancelJoinGroupRequestRequest as CancelJoinGroupRequestRequestOriginal,
  CancelJoinGroupRequestResponse as CancelJoinGroupRequestResponseOriginal,
  JoinGroupRequestCancelled as JoinGroupRequestCancelledOriginal,
  ApproveJoinGroupRequestsRequest as ApproveJoinGroupRequestsRequestOriginal,
  ItemsToUpdate as ItemsToUpdateOriginal,
  ItemsToUpdateWithLiterals as ItemsToUpdateWithLiteralsOriginal,
  ApproveJoinGroupRequestsResponse as ApproveJoinGroupRequestsResponseOriginal,
  JoinGroupRequestApproved as JoinGroupRequestApprovedOriginal,
  RejectJoinGroupRequestsRequest as RejectJoinGroupRequestsRequestOriginal,
  Rejection as RejectionOriginal,
  RejectJoinGroupRequestsResponse as RejectJoinGroupRequestsResponseOriginal,
  JoinGroupRequestRejected as JoinGroupRequestRejectedOriginal,
  ListJoinGroupRequestsRequest as ListJoinGroupRequestsRequestOriginal,
  OwnershipFilter as OwnershipFilterOriginal,
  OwnershipFilterWithLiterals as OwnershipFilterWithLiteralsOriginal,
  ListJoinGroupRequestsResponse as ListJoinGroupRequestsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  QueryJoinGroupRequestsRequest as QueryJoinGroupRequestsRequestOriginal,
  Query as QueryOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryJoinGroupRequestsResponse as QueryJoinGroupRequestsResponseOriginal,
  RejectAllJoinGroupRequestsRequest as RejectAllJoinGroupRequestsRequestOriginal,
  RejectAllJoinGroupRequestsResponse as RejectAllJoinGroupRequestsResponseOriginal,
  ApproveAllJoinGroupRequestsRequest as ApproveAllJoinGroupRequestsRequestOriginal,
  ApproveAllJoinGroupRequestsResponse as ApproveAllJoinGroupRequestsResponseOriginal,
  ListAllJoinGroupRequestsRequest as ListAllJoinGroupRequestsRequestOriginal,
  ListAllJoinGroupRequestsResponse as ListAllJoinGroupRequestsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './social-groups-v2-join-group-request-join-group-requests.types.js';
